import { Dispatch } from 'react';
import { InsuranceJourneyAboutTermsOfBusinessAndFairUseDetailsType } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const AboutTermsOfBusinessAndFairUsePageEventHandlers = (
  aboutTermsOfBusinessAndFairUseDetails: InsuranceJourneyAboutTermsOfBusinessAndFairUseDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeReadAndAgreeWithTerms: (value: boolean) => {
      dispatch({
        type: 'set-about-terms-of-business-and-fair-use-details',
        aboutTermsOfBusinessAndFairUseDetails: {
          ...aboutTermsOfBusinessAndFairUseDetails,
          readAndAgreeWithTerms: value
        }
      });
    },

    onChangeConsentForDetailsToBePassed: (value: boolean) => {
      dispatch({
        type: 'set-about-terms-of-business-and-fair-use-details',
        aboutTermsOfBusinessAndFairUseDetails: {
          ...aboutTermsOfBusinessAndFairUseDetails,
          consentForDetailsToBePassed: value
        }
      });
    }
  };
};
